const toast = (text, last, duration) => {
    //1.初始化样式
    if (!document.getElementById('css_tips_pop')) {
      var css = document.createElement('style');
      css.type = 'text/css';
      css.id = 'css_tips_pop';
      css.innerHTML =
        `.error-tips{width:100%;left:0;top:70%;margin-top:-20px;position:fixed;z-index:5201;text-align:center;}.error-tips span{background-color:rgba(0,0,0,0.8);padding:8px 12px;display:inline-block;margin:0 auto;color:#FFFFFF;border-radius:4px;font-size:14px;}\
                  .error-tips-ani {animation: error-tips-ani 1s ease-in-out 1;-webkit-animation: error-tips-ani 1s ease-in-out 1;opacity:0;}\
                  @keyframes error-tips-ani {from {opacity:1;}to {opacity:0;}}\
                  @-webkit-keyframes error-tips-ani {from {opacity:1;}to {opacity:0;}}`;
      document.getElementsByTagName('head')[0].appendChild(css);
    }

    last = last || 2000;
    duration = duration || 1000;

    if (document.getElementById("mod_tips_pop")) {
      document.getElementById("mod_tips_pop").parentNode.removeChild(document.getElementById("mod_tips_pop"));
    }
    //'<div class="error-tips" id="mod_tips_pop"><span>${tips}</span></div>';
    var div = document.createElement("div");
    var span = document.createElement("span");
    var spantext = document.createTextNode(text);
    div.id = "mod_tips_pop";
    div.className = "error-tips";
    span.appendChild(spantext);
    div.appendChild(span);
    document.body.appendChild(div);

    setTimeout(function () {
      div.className = "error-tips error-tips-ani";
      setTimeout(function () {
        if (document.getElementById("mod_tips_pop")) {
          document.getElementById("mod_tips_pop").parentNode.removeChild(document.getElementById("mod_tips_pop"));
        }
      }, duration);
    }, last)
}

const debug = (...ary) => {
    if (!/eruda=/.test(location.href)) {
        return;
    }
    console.log(...ary);
}


export {
    toast,
    debug,
}


// WEBPACK FOOTER //
// ./node_modules/@kkmh/utils/src/message.js